import dateformat from 'dateformat';
import isEmpty from 'lodash/isEmpty';

export default function getDateAndTime(utcTime) {
  if (!isEmpty(utcTime)) {
    const dateObject = new Date(`${utcTime}Z`);
    // Format: October 12, 2017 7:00 pm
    return dateformat(dateObject, 'mmmm d, yyyy h:MM tt');
  }
  return '';
}
